import React from 'react'
import { useSalonContext } from "@customer/components/pages/Salon/context"
import Info from '@blocks/Info'
import { ReactComponent as PayIcon } from '@icons/pay.svg'
import Button from '@blocks/Button'
import useSidepanel from '@hooks/useSidepanel'
import SalonPaymentSidepanel from './components/PaymentSidepanel'

export default function SalonCurrentStatus() {
    const { salon } = useSalonContext()
    const sidepanel = useSidepanel()
    const openSidepanel = () => sidepanel.open(SalonPaymentSidepanel, { salon })
    
    if (!salon.state.is_paid) 
        return <Button type="secondary" width="auto" icon={<PayIcon />} onClick={openSidepanel}>Payment</Button>

    return <Info transparent label="Paid" icon={<PayIcon />} />
}